import React from 'react';
import PropTypes from 'prop-types';
import { graphql, StaticQuery } from 'gatsby';
import ProjectCard from './item-card/ProjectCard';

class OpenSourceList extends React.Component {
  render() {
    const { data } = this.props;
    const { edges: projects } = data.allMarkdownRemark;

    return (
      <div className="cards-container grid-container flex-start">
        {projects &&
          projects.map(({ node: project }) => (
            <ProjectCard
              key={project.id}
              id={project.id}
              title={project.frontmatter.title}
              featuredImage={project.frontmatter.featuredimage}
              summary={project.frontmatter.summary}
              type={project.frontmatter.templateKey}
              website={project.frontmatter.website}
              githubRepo={project.frontmatter.github}
              cardColumns={6}
            />
          ))}
      </div>
    );
  }
}

OpenSourceList.propTypes = {
  data: PropTypes.shape({
    allMarkdownRemark: PropTypes.shape({
      edges: PropTypes.array,
    }),
  }),
};

export default () => (
  <StaticQuery
    query={graphql`
      query OpenSourceProjectsQuery {
        allMarkdownRemark(
          sort: { fields: [frontmatter___title], order: ASC }
          filter: { frontmatter: { templateKey: { eq: "project" } } }
        ) {
          edges {
            node {
              ...ProjectCardFragment
            }
          }
        }
      }
    `}
    render={(data, count) => <OpenSourceList data={data} count={count} />}
  />
);
